import Vue from "vue";
import VueRouter from "vue-router";
import Carpool from "@/views/Carpool.vue";
import Children from "@/views/Children.vue";
import Corporate from "@/views/Corporate.vue";
import Health from "@/views/Health.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/carpool/:nano",
    name: "Carpool",
    component: Carpool,
  },
  {
    path: "/children/:childrenNano",
    name: "Children",
    component: Children,
  },
  {
    path: "/corporate/:corporateNano",
    name: "Corporate",
    component: Corporate,
  },
  {
    path: "/health/:healthNano",
    name: "Health",
    component: Health,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
